import Styles from './SelectableBrandKitWidget.module.scss'
import { useRadioGroupState } from '@react-stately/radio'
import { BrandKitWidget } from '../BrandKitWidget/BrandKitWidget'
import { BrandKitWidgetProps } from '../BrandKitWidget/Types'
import { Radio } from 'components/RadioGroup/Radio'
import { RadioContext } from 'components/RadioGroup/RadioContext'
import { RadioBullet } from 'components/RadioGroup/RadioBullet'

interface SelectableBrandKitWidgetProps extends BrandKitWidgetProps {
  value?: string | number
  radioGroupState: ReturnType<typeof useRadioGroupState>
}

const SelectableBrandKitWidget = ({ brandKit, value, radioGroupState }: SelectableBrandKitWidgetProps) => {
  return (
    <div className={Styles.container} data-testid="selectable-brand-kit-widget">
      <RadioContext.Provider value={radioGroupState}>
        <Radio
          value={value?.toString() as string}
          className={Styles.radioWrapper}
          classNames={{
            selected: Styles.selectedRadio,
            focused: Styles.focusedRadio,
            hovered: Styles.hoveredRadio,
          }}
          hideRadio
        >
          {(radioProps) => (
            <>
              <div className={Styles.radioBullet}>
                <RadioBullet {...radioProps} size={20} />
              </div>
              <div className={Styles.widgetContainer}>
                <BrandKitWidget brandKit={brandKit} />
              </div>
            </>
          )}
        </Radio>
      </RadioContext.Provider>
    </div>
  )
}

export { SelectableBrandKitWidget }
